export enum HttpStatusCodes {
  OK = 200,
}
